<template>
	<img
        width="24"
        class="flag"
        v-if="country"
        :src="country.local"
        :alt="country.name"
        v-tippy="country.name"
    />
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		name: 'ColumnFlag',
		props: {
			rowData: {
				type: Object,
				required: true,
			},
			rowIndex: {
				type: Number,
			},
		},
		computed: {
			country() {
                return this.rowData.country;
			},
		},
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>
